if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        
        this.elements = {
          depositInput: this.querySelector('input.product-deposit-variant-id'),
          loadingSpinner: this.querySelector('.loading-overlay__spinner'),
          submitButton: this.querySelector('[type="submit"]')
        }

        if (document.querySelector('cart-drawer')) this.elements.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        
        const depositRequired = await this.checkIfDepositRequired();

        if (this.elements.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.elements.submitButton.setAttribute('aria-disabled', true);
        this.elements.submitButton.classList.add('loading');
        this.elements.loadingSpinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.elements.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.elements.submitButton.setAttribute('aria-disabled', true);
              this.elements.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.elements.submitButton.classList.remove('loading');
            this.elements.depositInput.disabled = true;
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.elements.submitButton.removeAttribute('aria-disabled');
            this.elements.loadingSpinner.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      async getCart() {
        try {
          const response = await fetch(window.routes.cart_url + '.json');
          const cart = await response.json();
          return cart;
        }
        catch (error) {
          console.error('Error fetching cart:', error)
        }
      }

      async isDepositProductInCart() {
        const cart = await this.getCart();
        if (!cart || !cart.items) return false;

        return cart.items.some(item => item.product_type === 'Deposit');
      }

      async checkIfDepositRequired() {
        if (!window.deposit || !window.deposit.enabled) return false;
        
        // check if there's already a deposit product in the cart
        const isDepositProductInCart = await this.isDepositProductInCart();
        if (isDepositProductInCart) {
          console.info('Deposit product already in cart. Skipping deposit requirement check.');
          this.elements.depositInput.disabled = true;
          return false;
        }

        // check if the current variant requires a deposit
        // Note: the value of the input[name=id] is set by the VariantSelect class. See global.js
        const currentVariantDepositRequired = (this.form.querySelector('[name=id]').dataset.depositRequired === 'true');
        
        if (currentVariantDepositRequired) {
          console.info('Current variant requires a deposit. Enabling deposit requirement.');
          this.elements.depositInput.disabled = false;
          return true;
        }
      }
    }
  );
}
